if (!customElements.get('custom-modal')) {
  class Modal extends HTMLElement {
    constructor() {
      super();
      this.activeId = null;
    }
    
    close() {      
      document.querySelector(`[data-drawer-action="open"][data-drawer-id="${this.activeId}"]`)?.focus();
      switch(this.direction) {
        case 'left':
          this.classList.add('opacity-0', '-translate-x-full')
          setTimeout(() => {
            this.classList.remove('opacity-0', '-translate-x-full')
          }, 500);
        break;
        case 'center':
          this.classList.add('opacity-0');
          setTimeout(() => {
            this.classList.remove('opacity-0');
          }, 500);
        break;
        case 'right': 
          this.classList.add('opacity-0', 'translate-x-full')
          setTimeout(() => {
            this.classList.remove('opacity-0', 'translate-x-full')
          }, 500);
        break;
      }
        
      this.template.innerHTML = this.innerHTML;
      
      setTimeout(() => {
        this.classList = '';
        this.classList.add('hidden');
        document.body.classList.remove('overlay');
        this.innerHTML = '';
        this.activeId = null;
      }, 500);
      
    }
    
    connectedCallback() {
      window.addEventListener('click', (e) => {
        if (e.target.tagName === 'custom-modal') {
          this.close();
        }
        
        const clickedElement = e.target.closest('[data-drawer-action]');
        if (!clickedElement) return;
        
        const {
          drawerAction,
          drawerId
        } = clickedElement.dataset;
                        
        switch (drawerAction) {
          case 'open':    
            this.template = document.querySelector(`[data-drawer-content="${drawerId}"]`); 
            if (!this.template) return;       
            this.direction = this.template.dataset?.direction ?? 'left';
            this.classList.add('opacity-0');
            
            if (this.activeId !== drawerId) {
              this.activeId = drawerId;
              const content = this.template.content?.cloneNode(true) || this.template.cloneNode(true);
              this.replaceChildren(content);
              this.classList.remove('hidden');
              this.classList.add(this.direction);
              
              ['keydown', 'click'].forEach(eventType => window.addEventListener(eventType, (e) => {
                if (e.key !== 'Escape' && e.target.tagName !== 'CUSTOM-MODAL') return;
                this.close();
              },  { once: true }));
              
              setTimeout(() => {
                document.body.classList.add('overlay');
                this.classList.add('top-0', 'bottom-0', 'left-0', 'w-full', 'h-full', 'z-10', 'opacity-0');
                this.querySelector('[data-drawer-action="close"]').focus();
              }, 10);
            }
            
            switch(this.direction) {
              case 'left':
                this.classList.add('-translate-x-full', 'transition-all', 'duration-500');
              break;
              case 'center':
                this.classList.add('transition-all', 'duration-500');
              break;
              case 'right': 
                this.classList.add('translate-x-full', 'transition-all', 'duration-500');
              break;
            }
            
            setTimeout(() => {
              switch(this.direction) {
                case 'left':
                  this.classList.remove('opacity-0', '-translate-x-full')
                break;
                case 'center':
                  this.classList.remove('opacity-0')
                break;
                case 'right': 
                  this.classList.remove('opacity-0', 'translate-x-full')
                break;
              }
            }, 10);
          break;
          case 'close':
            this.close();
          break;
          default: break;
        }
      });
    }
  }
  
  customElements.define('custom-modal', Modal);
}